import React, { useEffect, useState, useCallback } from 'react';
import api from '../services/api';

const STEPS = ['lead', 'verified', 'visa_approved', 'enrolled'];
const STEP_LABELS = {
  lead:         'Lead',
  verified:     'Verified',
  visa_approved:'Visa Approved',
  enrolled:     'Enrolled',
};
const STATUS_STEP = { lead: 0, verified: 1, visa_approved: 2, enrolled: 3 };

export default function MyReferrals() {
  const [referrals, setRef] = useState([]);
  const [loading, setLoad]  = useState(true);

  const load = useCallback(async () => {
    try {
      const { data } = await api.get('/referral/student/referrals/');
      setRef(data);
    } catch {/* silent */} finally { setLoad(false); }
  }, []);

  useEffect(() => { load(); }, [load]);

  if (loading) return <div className="page-loading">Loading…</div>;

  return (
    <div className="dashboard">
      <div className="dash-welcome">
        <div>
          <h1>My Referrals</h1>
          <p>Track every student you've referred and their admission progress.</p>
        </div>
      </div>

      {referrals.length === 0 ? (
        <div className="empty-state">
          <div className="empty-icon">🎯</div>
          <h3>No referrals yet</h3>
          <p>Go to your dashboard and add students you've referred.</p>
        </div>
      ) : (
        <div className="ref-cards">
          {referrals.map(ref => {
            const step = STATUS_STEP[ref.status] ?? 0;
            return (
              <div key={ref.id} className="ref-card">
                <div className="ref-card-top">
                  <div className="ref-avatar">{ref.referred_name?.charAt(0).toUpperCase()}</div>
                  <div className="ref-details">
                    <strong>{ref.referred_name}</strong>
                    <span>{ref.referred_email}</span>
                    <span className="ref-phone">{ref.referred_phone}</span>
                  </div>
                  <div className="ref-money">
                    {ref.total_earned > 0 && (
                      <span className="earned-badge">₹{ref.total_earned.toLocaleString()} earned</span>
                    )}
                    {ref.pending_amount > 0 && (
                      <span className="pending-badge">₹{ref.pending_amount.toLocaleString()} pending</span>
                    )}
                  </div>
                </div>

                {/* Progress Timeline */}
                <div className="timeline">
                  {STEPS.map((s, i) => (
                    <div key={s} className={`timeline-step ${i <= step ? 'done' : ''} ${i === step ? 'current' : ''}`}>
                      <div className="tl-dot">{i <= step ? '✓' : i + 1}</div>
                      <div className="tl-label">{STEP_LABELS[s]}</div>
                      {i < STEPS.length - 1 && <div className={`tl-line ${i < step ? 'done' : ''}`} />}
                    </div>
                  ))}
                </div>

                <div className="ref-card-footer">
                  <span className={`status-badge status-${ref.status}`}>{ref.status.replace('_', ' ')}</span>
                  <span className="ref-date">Referred {new Date(ref.created_at).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' })}</span>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
